import {Injectable} from '@angular/core';
import {CommunicationService} from '../http/communication.service';
import {catchError, Observable} from 'rxjs';
import  {CommonDashboardFilterResponse, TopLevelMetricsResponse} from './types';

@Injectable({
  providedIn: 'root'
})
export class CommonDashboardService {

  constructor(private communicationService: CommunicationService) {}

  getTopLevelMetrics(): Observable<TopLevelMetricsResponse>{
    return this.communicationService.httpGet<TopLevelMetricsResponse>( '/dashboard/common/top-level-metrics').pipe(
      catchError((error) => {
          console.error('Error fetching top level metrics', error);
          throw error;
        }
      )
    )
  };

  getFilters(): Observable<CommonDashboardFilterResponse>{
    return this.communicationService.httpPost<CommonDashboardFilterResponse>( '/dashboard/common/filters', {}).pipe(
      catchError((error) => {
          console.error('Error fetching filters', error);
          throw error;
        }
      )
    )
  };
}
